<template>
  <div class="seller-leftNav">
    <a href="" target="_blank" ref="target"></a>
    <el-menu :default-active="defaultActive" :router="true">
      <!-- 首页 -->
      <el-menu-item class="seller-leftNav-item" index="/dashboard">
        <i class="seller-leftNav-item-icon iconfont iconhome-leftNav" />
        <span class="seller-leftNav-item-text">首页</span>
      </el-menu-item>
      <!-- 店铺管理 -->
      <el-submenu index="2">
        <template slot="title">
          <i class="seller-leftNav-item-icon iconfont iconshow-leftNav" />
          <span class="seller-leftNav-item-text">店铺管理</span>
        </template>
        <div @contextmenu="rightShow('/shop')" >
          <el-menu-item index="/shop/shopee" class="seller-leftNav-subItem">Shopee</el-menu-item>
          <el-menu-item index="/shop/tiktok" class="seller-leftNav-subItem">Tiktok</el-menu-item>
        </div>
      </el-submenu>
      <!-- 订单管理 -->
      <div @contextmenu="rightShow('/order')" ><el-menu-item class="seller-leftNav-item" index="/order">
        <i class="seller-leftNav-item-icon iconfont iconorder-leftNav" />
        <span class="seller-leftNav-item-text">订单管理</span>
      </el-menu-item></div>
      <!-- 出库管理 -->
      <div @contextmenu="rightShow('/outbound')" ><el-menu-item class="seller-leftNav-item" index="/outbound">
        <i class="seller-leftNav-item-icon iconfont iconwaybill-leftNav" />
        <span class="seller-leftNav-item-text">出库管理</span>
      </el-menu-item></div>
      <!-- 入库管理 -->
      <div @contextmenu="rightShow('/inbound')" ><el-menu-item class="seller-leftNav-item" index="/inbound">
        <i class="seller-leftNav-item-icon iconfont iconstorage-leftNav" />
        <span class="seller-leftNav-item-text">入库管理</span>
      </el-menu-item></div>
      <!-- 商品管理 -->
      <div @contextmenu="rightShow('/sku')" ><el-menu-item class="seller-leftNav-item" index="/sku">
        <i class="seller-leftNav-item-icon iconfont iconproduct-leftNav" />
        <span class="seller-leftNav-item-text">商品管理</span>
      </el-menu-item></div>
      <!-- 库存管理 -->
      <div @contextmenu="rightShow('/store')" ><el-menu-item class="seller-leftNav-item" index="/store">
        <i class="seller-leftNav-item-icon iconfont iconstore-leftNav" />
        <span class="seller-leftNav-item-text">库存管理</span>
      </el-menu-item></div>
      <!-- 仓库管理 -->
      <div @contextmenu="rightShow('/warehouse')" ><el-menu-item class="seller-leftNav-item" index="/warehouse">
        <i class="seller-leftNav-item-icon iconfont iconwarehouse-leftNav" />
        <span class="seller-leftNav-item-text">仓库管理</span>
      </el-menu-item></div>
      <!-- 账号充值 -->
      <div @contextmenu="rightShow('/recharge')" ><el-menu-item class="seller-leftNav-item" index="/recharge">
        <i class="seller-leftNav-item-icon iconfont iconrecharge-leftNav" />
        <span class="seller-leftNav-item-text">账号充值</span>
      </el-menu-item></div>
    </el-menu>

    <!-- 右键菜单 start -->
     <vue-context-menu
      :contextMenuData="contextMenuData"
      @attention="attention" />
    <!-- 右键菜单 end -->
  </div>
</template>

<script>
export default {
  name: 'sellerLeftNav',
  mounted () {
    this.defaultActive = this.$route.fullPath
  },
  data () {
    return {
      defaultActive: '', // 默认高亮项
      // 右键菜单
      contextMenuData: { // 右键弹窗位置变量
        axis: {
          x: null,
          y: null
        },
        menulists: [ // 右键弹窗配置变量
          {
            fnHandler: 'attention',
            btnName: '在新窗口打开'
          }
        ],
        linkURL: '' // 右键菜单点击的模块链接地址
      }
    }
  },
  methods: {
    /**
     * 右键弹出菜单显示方法
     */
    rightShow (URL) {
      event.preventDefault() // 禁用浏览器原生右键菜单
      var x = event.clientX
      var y = event.clientY
      this.contextMenuData.axis = {
        x,
        y
      }
      this.linkURL = URL
    },

    attention () {
      if (this.linkURL) {
        let target = this.$refs.target
        console.log(this.linkURL)
        target.setAttribute('href', `http://vip.cang100.com${this.linkURL}`)
        target.click()
      }
    }
  }
}
</script>

<style lang="scss">
.seller-leftNav {
  height: 100%;
}
.el-menu {
  min-height: 100%;
  border-right: solid 3px #006A71;
}
// 导航item通用
.seller-leftNav-item, .el-submenu__title, .el-submenu .seller-leftNav-subItem {
  height: 63px;
  display: flex;
  align-items: center;
  margin: 5px 0;
  padding-left: 30px !important;
  position: relative;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  .seller-leftNav-item-icon {
    color: #666;
    font-size: 18px;
    margin-right: 10px;
  }
  .seller-leftNav-item-text {
    color: #666;
    font-size: 14px;
    letter-spacing: .5px;
  }
  // 一级导航项'触摸'样式
  &:hover {
    background: #D2E8E6;
  }
  // 一级导航项'已选择'样式
  &.is-active, &.is-active:hover {
    .seller-leftNav-item-icon, .seller-leftNav-item-text {
      color: #FFF;
    }
    background: #68B0AB;
  }
}

// 二级导航项 submenu
.el-submenu.is-active .el-submenu__title {
  .seller-leftNav-item-text {
    color: #006A71;
  }
}
// 二级导航 item行内样式
.el-menu--inline {
  background: #EEE;
  // 二级导航项 subItem
  .seller-leftNav-subItem {
    margin: 0;
    padding-left: 50px !important;
    color: #666;
    font-weight: 600;
    &:focus {
      color: #666;
      background: none;
    }
    // 二级导航项'已选择'样式
    &.is-active {
      color: #FFF;
      background: #68B0AB;
    }
    // 二级导航项'触摸'样式
    &:hover {
      background: #D2E8E6;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/component/leftNav.vue